module.exports = __webpack_public_path__ + "img/mixed-gradient.59d2d17.webp";